import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';
import {ModalTypes, QuestionType} from 'src/app/modules/shared/constants';
import {PolicyEditQuestion} from 'src/app/modules/shared/models/policy.model';
import {QuestionGroups} from 'src/app/modules/shared/models/question-groups';
import {Question, ShoppingCartItem} from 'src/app/modules/shared/models/underwriter.model';
import {QuestionFlowSessionQuery} from 'src/app/modules/shared/questions/state/question-flow-session.query';
import {FlowPlayerService} from 'src/app/modules/shared/services/flow-player.service';
import {GlobalQuestionService} from 'src/app/modules/shared/services/global-question.service';

declare var $: any;

@Component({
    selector: 'app-clam-edit-event-details',
    templateUrl: './clam-edit-event-details.component.html',
    styleUrls: ['./clam-edit-event-details.component.scss'],
    standalone: false
})
export class ClamEditEventDetailsComponent implements OnInit {

  @Input() cart_item: ShoppingCartItem;
  @Input() showItemDetails = false;
  @Input() display_type: ModalTypes;
  @Output() removeItem = new EventEmitter<{ item: ShoppingCartItem }>();

  question: Question;
  claim_details: any = {};
  questions: Question[];
  isSavingData = false;
  session_details: any;
  childrenQuestions: Question[] = [];
  loading = false;
  QuestionType = QuestionType;
  questionGroups: QuestionGroups[] = [];
  responseQuestions: Question[] = [];
  isSkipped = false;
  isGroupsLoading = false;
  responsesSubscription: Subscription;
  constructor(
    private globalQuestionService: GlobalQuestionService,
    private sessionQuery: QuestionFlowSessionQuery,
    private flowPlayer: FlowPlayerService
  ) { }

  ngOnInit(): void {
    this.session_details = this.sessionQuery.getValue();
    /*this.getFlowQuestions(this.cart_item?.flow_id, this.cart_item?.item_id, this.cart_item?.class_id);*/
    this.populateClaimDetails();
    this.getQuestionGrouping();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes?.showItemDetails?.currentValue !== changes?.showItemDetails?.previousValue) {
      this.showItemDetails = changes?.showItemDetails?.currentValue;
    }
    if (changes?.cart_item?.currentValue !== changes?.cart_item?.previousValue) {
      this.cart_item = changes?.cart_item?.currentValue;
    }
    if (this.cart_item) {
      //console.log(this.cart_item)
      //this.getQuestions();
    }
    
  }

  populateClaimDetails(): void {
    this.globalQuestionService.getClaim()
      .subscribe((c: any[]) => {
        
        if (!c?.length) {
          return;
        }
        
        this.claim_details.claim_id = c[0]?.claim_id;
        this.claim_details.claim_name = c[0]?.claim_name;
        this.claim_details.claim_status = c[0]?.claim_status;
        this.claim_details.policy_id = c[0]?.policy_id;
        this.claim_details.version_id = c[0]?.version_id;
        this.claim_details.claim_version_id = c[0]?.claim_version_id;
      });
  }

  getItemChildrenQuestions(question: Question): Question[] {
    const childQuestions = this.childrenQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
    return this.childrenQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
  }

  questionResponse(event: Question): void {
    
    if (event?.dependant_flow_id) {
      this.question = event;
      $('#modal-additional').modal('show');
    } else {
      //const questionIndex = this.questions?.findIndex(question => question.cent_aq_question_id === event.cent_aq_question_id);
      //if (questionIndex > -1) {
        if (!this.isSavingData) {
          this.isSavingData = true;
          //this.questions[questionIndex] = event;
          this.globalQuestionService.saveIndividualAnswer(event, event?.item_id)
            .subscribe(() => {
              this.globalQuestionService.setSummaryDataObservable(true);
              this.globalQuestionService.evaluateClaimCompletionStatus(this.session_details?.session_id).subscribe({
                next: () => {
                  this.populateClaimDetails();
                  this.isGroupsLoading = true;
                  this.getQuestionGrouping();
                }
              });
            });
        }
      //}
    }
  }

  getQuestions(): void {
    this.isSkipped = false;
    this.loading = true;
    this.isGroupsLoading = false;
    this.questions = [];
    this.childrenQuestions = [];
    
    this.responsesSubscription = this.globalQuestionService.getResponses()
      .subscribe((questions: Question[]) => {
        if (!questions?.length) {
          this.loading = false;
          return;
        }

        if (questions?.length) {
          this.responseQuestions = questions;
          this.questions = [];
          this.childrenQuestions = [];

          for (const q of questions) {
            if (q?.skipped === 1) {
              this.isSkipped = true;
            }
            q.isEdit = true;
            try { q.skipped_details = JSON.parse(q.skipped_details); } catch { }
            if (this.display_type === ModalTypes.event_details
              ? q?.item_id?.toString() === this.cart_item?.item_id?.toString() && q?.product_class_id?.toString() === this.cart_item?.class_id?.toString() && q?.flow_id?.toString() === this.cart_item?.flow_id?.toString()
              : q?.item_id?.toString() === this.cart_item?.item_id?.toString() && q?.product_class_id?.toString() === this.cart_item?.class_id?.toString()) {
             
              if (q?.parent_control) {
                this.childrenQuestions.push(q);
                const parentQuestion = questions.find(x => x?.cent_aq_question_id === q?.parent_control);
                if (parentQuestion) {
                  if (!this.questions?.some(x => x.cent_aq_question_id === parentQuestion?.cent_aq_question_id && x?.item_id === q?.item_id)) {
                    this.questions.push(parentQuestion);
                  }
                } else {
                  this.questions.push(q);
                }
              } else {
                if (!this.questions?.some(x => x?.cent_aq_question_id === q?.cent_aq_question_id && x?.item_id === q?.item_id)) {
                  this.questions.push(q);
                }
              }
            }
          }
          
          // console.log('[getQuestions] matched questions count:', this.questions.length, 'calling getQuestionGrouping:', this.questions.length > 0);
          this.getQuestionGrouping();
         
        }
        this.loading = false;
      });
  }

  getQuestionGrouping(): void {
    this.questionGroups = [];
    const startTime = Date.now();
    this.isGroupsLoading = true;
   // if (this.questions?.length) {
     // if (this.display_type === ModalTypes.item_details) {
        this.globalQuestionService.getQuestionGrouping()
          .subscribe((groups: any) => {
            
            if (groups?.length) {
              for (const g of groups) {
                try { g.skipped_details = JSON.parse(g.skipped_details); } catch { }
                g.isEdit = true;
                const existing = this.questionGroups.find(x => x.group_name === g.group_name);
                if (!existing) {
                  const questionGroup = new QuestionGroups();
                  questionGroup.group_type = g.group_type;
                  questionGroup.group_name = g.group_name;
                  questionGroup.class_id = g.class_id == 0 ? this.cart_item?.class_id : g.class_id;
                  questionGroup.item_id = g.item_id == '0' ? this.cart_item?.item_id : g.item_id;
                  questionGroup.questions = [g];
                  this.questionGroups.push(questionGroup);
                } else {
                  existing.questions.push(g);
                }
              }
              
            }
            const elapsed = Date.now() - startTime;
            const remaining = Math.max(0, 1000 - elapsed);
            setTimeout(() => {
              this.isGroupsLoading = false;
              this.isSavingData = false;
            }, remaining);
          });
    
  }

  get eventDetailQuestions(): any[] {
    //console.log(this.questionGroups.find(g => g.group_type === 'event detail')?.questions)
    return this.questionGroups.find(g => g.group_type === 'event detail')?.questions ?? [];
  }

  get detailGroups(): QuestionGroups[] {
    return this.questionGroups.filter(g => g.group_type === 'detail');
  }

  get policeReportQuestions(): any[] {
    return this.questionGroups.find(g => g.group_type === 'police_report')?.questions ?? [];
  }

  getChildQuestions(question_id: number, item_id: string): Question[] {
    if (this.childrenQuestions?.length) {
      return this.childrenQuestions?.filter(x => x?.parent_control === question_id && x?.item_id === item_id);
    } else {
      return [];
    }
  }
  trackByGroup(_: number, group: QuestionGroups): string {
    return group.group_type + '_' + group.item_id;
  }

  groupHasHighlight(group: QuestionGroups): boolean {
    return group?.questions?.some(q => !!q?.highlight);
  }

  startFlow(): void {
    //$('#modal-miniflow').modal('show');
    this.globalQuestionService.saveAnswer(this.session_details.session_id, 1073, 0, '0', '10', 0, '')
      .subscribe(result => {
        this.flowPlayer.startFlow(0, this.question.dependant_flow_id, this.session_details.category_id, this.session_details.group_id, this.question.item_id, this.session_details.session_id, this.session_details.css, 0);
      },
        err => {
          console.log(err);
        });
  }

  submitResponse(event): void {
    console.log(event)
  }

}
